import { Injectable } from '@angular/core';

import { RestClient, apiVersion } from '../base/rest-client';

@Injectable()
export class RestClientDiagnosisService extends RestClient {
  /**
   * コンストラクタ
   *
   */
  /**
   * constructor
   *
   */
  constructor() {
    super();
  }
}
